import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '../pages/NotFound.vue'
// import Dashboard from '../pages/Dashboard.vue'
// import Consumen from '../pages/Consumen.vue'
// import ConsumenDetail from '../pages/ConsumenDetail.vue'
// import Billing from '../pages/Billing.vue'
// import Products from '../pages/Products.vue'
// import HSM from '../pages/HSM.vue'
// import WA_Connect from '../pages/WA_Connect.vue'
// import ProductsDetail from '../pages/ProductDetail.vue'
// import Reports from '../pages/Report.vue'

//authentication
// import Login from '../pages/authentication/Login.vue'
import Register from '../pages/authentication/Register.vue'
import Verify from '../pages/authentication/Verify.vue'
import ForgotPassword from '../pages/authentication/ForgotPassword.vue'
import ChangePassword from '../pages/authentication/ChangePassword.vue'
import ResetPassword from '../pages/authentication/ResetPassword.vue'
import Profile from '../pages/Profile.vue'
import UpgradeAccount from '../pages/UpgradeAccount.vue'

import layouts from '../layout'
import store from '../store'

Vue.use(Router)


const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			alias: '/login',
			name: 'login',
			component: () => import(/* webpackChunkName: "login" */ `../pages/authentication/Login.vue`),
			meta: {
				layout: layouts.contenOnly
			}
		},
		{
			path: '/',
			alias: '/change-passwprd',
			name: 'change_password',
			component: () => import(/* webpackChunkName: "change-password" */ `../pages/authentication/ChangePassword.vue`),
			meta: {
				layout: layouts.contenOnly
			}
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: () => import(/* webpackChunkName: "dashboard" */ `../pages/Dashboard.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/dashboard']
			}
		},
		{
			path: '/consumen',
			name: 'consumen',
			component: () => import(/* webpackChunkName: "consumen" */ `../pages/Consumen.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/consumen']
			}
		},
		{
			path: '/consumen/:consumen',
			name: 'consumen_detail',
			component: () => import(/* webpackChunkName: "consumen-detail" */ `../pages/ConsumenDetail.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				tags: ['/consumen-detail']
			}
		},
		{
			path: '/products',
			name: 'products',
			component: () => import(/* webpackChunkName: "products" */ `../pages/Products.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/products']
			}
		},
		{
			path: '/business',
			name: 'business',
			component: () => import(/* webpackChunkName: "business" */ `../pages/Business.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/business']
			}
		},
		{
			path: '/business/:fb_identity',
			name: 'identity_detail',
			component: () => import(/* webpackChunkName: "business-identity-detail" */ `../pages/PriceModelDetail.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/identity-detail']
			}
		},
		{
			path: '/bussiness/market',
			name: 'bussiness_market',
			component: () => import(/* webpackChunkName: "bussiness-market" */ `../pages/bussiness/market.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/bussiness/market']
			}
		},
		{
			path: '/bussiness/market/prefix/:master_market_area/:market_name',
			name: 'bussiness_market_prefix',
			component: () => import(/* webpackChunkName: "business-market-prefix" */ `../pages/bussiness/MarketPrefix.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/bussiness/market/prefix']
			}
		},
		{
			path: '/bussiness/data',
			name: 'bussiness_data',
			component: () => import(/* webpackChunkName: "bussiness-data" */ `../pages/bussiness/Data.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/bussiness/data']
			}
		},
		{
			path: '/bussiness/report-transaction',
			name: 'bussiness_report_transaction',
			component: () => import(/* webpackChunkName: "bussiness-report-transaction" */ `../pages/bussiness/ReportTransaction.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/bussiness/report-transaction']
			}
		},
		{
			path: '/bussiness/monitoring',
			name: 'bussiness_monitoring',
			component: () => import(/* webpackChunkName: "bussiness-monitoring" */ `../pages/bussiness/Monitoring.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/bussiness/monitoring']
			}
		},
		{
			path: '/prefix',
			name: 'prefix',
			component: () => import(/* webpackChunkName: "prefix" */ `../pages/Prefix.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/prefix']
			}
		},
		{
			path: '/volta',
			name: 'volta',
			component: () => import(/* webpackChunkName: "prefix" */ `../pages/Volta.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/volta']
			}
		},
		{
			path: '/queue',
			name: 'queue',
			component: () => import(/* webpackChunkName: "queue" */ `../pages/Queue.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/queue']
			}
		},
		{
			path: '/products/:products',
			name: 'products_detail',
			component: () => import(/* webpackChunkName: "product-detail" */ `../pages/ProductDetail.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: false,
				tags: ['/products-detail']
			}
		},
		{
			path: '/template_messages',
			name: 'template_messages',
			component: () => import(/* webpackChunkName: "hsm" */ `../pages/HSM.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: false,
				tags: ['/template_messages']
			}
		},
		{
			path: '/wa_connect',
			name: 'wa_connect',
			component: () => import(/* webpackChunkName: "wa-connect" */ `../pages/WA_Connect.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: false,
				tags: ['/wa_connect']
			}
		},
		{
			path: '/notification',
			name: 'notification',
			component: () => import(/* webpackChunkName: "wa-connect" */ `../pages/Notification.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: false,
				tags: ['/notification']
			}
		},
		{
			path: '/log',
			name: 'log',
			component: () => import(/* webpackChunkName: "wa-connect" */ `../pages/Log.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: false,
				tags: ['/log']
			}
		},
		{
			path: '/biller_switcher',
			name: 'biller_switcher',
			component: () => import(/* webpackChunkName: "wa-connect" */ `../pages/BillerSwitcher.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: false,
				tags: ['/biller_switcher']
			}
		},
		{
			path: '/report',
			name: 'report',
			component: () => import(/* webpackChunkName: "report" */ `../pages/Report.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/report']
			}
		},
		{
			path: '/management_admin',
			name: 'management_admin',
			component: () => import(/* webpackChunkName: "consumen" */ `../pages/ManagementAdmin.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/management_admin']
			}
		},
		{
			path: '/log_admin_detail/:adminId',
			name: 'log_admin_detail',
			component: () => import(/* webpackChunkName: "consumen-detail" */ `../pages/LogAdminDetail.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				tags: ['/log_admin']
			}
		},
		{
			path: '/log_admin',
			name: 'log_admin',
			component: () => import(/* webpackChunkName: "consumen" */ `../pages/LogAdmin.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/log_admin']
			}
		},
		{
			path: '/finance',
			name: 'finance',
			component: () => import(/* webpackChunkName: "consumen" */ `../pages/Finance.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/finance']
			}
		},
		{
			path: '/finance/config',
			name: 'config',
			component: () => import(/* webpackChunkName: "finance-config" */ `../pages/FinanceConfig.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/finance/config']
			}
		},
		{
			path: '/finance/credit',
			name: 'credit',
			component: () => import(/* webpackChunkName: "finance-credit" */ `../pages/FinanceCredit.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/finance/credit']
			}
		},
		{
			path: '/finance/tax-invoice',
			name: 'tax-invoice',
			component: () => import(/* webpackChunkName: "finance-credit-invoice" */ `../pages/FinanceTaxInvoice.vue`),
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['/finance/tax-invoice']
			}
		},
		{
			path: '/logout',
			beforeEnter (to, from, next) {
				auth.logout()
				next({path:'/login'})
			}
		},
		{
			path: '/forgot-password',
			name: 'forgot-password',
			component: ForgotPassword,
			meta: {
				layout: layouts.contenOnly
			}
		},


		// Coming soon if to need
		{
			path: '/register',
			name: 'register',
			component: Register,
			meta: {
				layout: layouts.contenOnly
			}
		},
		{
			path: '/change-password',
			name: 'change-password',
			component: ChangePassword,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: false,
				tags: ['/dashboard']
			}
		},
		{
			path: '/verify/:verify_code',
			name: 'verify',
			component: Verify,
			meta: {
				layout: layouts.contenOnly
			}
		},
		{
			path: '/reset-password/:verify_code',
			name: 'reset-password',
			component: ResetPassword,
			meta: {
				layout: layouts.contenOnly
			}
		},
		{
			path: '/profile',
			name: 'profile',
			component: Profile,
			meta: {
				auth: true,
				layout: layouts.navLeft,
			}
		},
		{
			path: '/upgrade-account',
			name: 'upgrade-account',
			component: UpgradeAccount,
			meta: {
				auth: true,
				layout: layouts.navLeft,
			}
		},
		{
			path: '*',
			name: 'not-found',
			component: NotFound,
			meta: {
				layout: layouts.contenOnly
			}
		}
	]
})


const l = {
	contenOnly(){
		store.commit('setLayout', layouts.contenOnly)
	},
	navLeft(){
		store.commit('setLayout', layouts.navLeft)
	},
	navRight(){
		store.commit('setLayout', layouts.navRight)
	},
	navTop(){
		store.commit('setLayout', layouts.navTop)
	},
	navBottom(){
		store.commit('setLayout', layouts.navBottom)
	},
	set(layout){
		store.commit('setLayout', layout)
	}
}

//insert here login logic
const auth = {
	loggedIn() {
		return store.getters.isLogged
	},
	logout() {
		store.commit('setLogout')
	}
}

router.beforeEach((to, from, next) => {
	store.commit('isLoadingPage', true)
	let authrequired = false
	if(to && to.meta && to.meta.auth)
		authrequired = true

	if(authrequired) {
		if(auth.loggedIn()) {
			if(to.name === 'login') {
				next({path:'/dashboard'})
				// window.location.href = '/dashboard'
				return false
			} else {
				next()
			}
		} else {
			if(to.name !== 'login'){
				next({path:'/login'})
				// window.location.href = '/login'
				return false
			}
			next()
		}
	} else {
		if(auth.loggedIn() && to.name === 'login'){
			// next({path:'/dashboard'})
			window.location.href = '/dashboard'
			return false
		} else {
			next()
		}
	}

	if(to && to.meta && to.meta.layout){
		l.set(to.meta.layout)
	}
})

router.afterEach((to, from) => {
	store.commit('isLoadingPage', false)
	// console.log($store.getters.isLoading)
	setTimeout(()=>{
		store.commit('setSplashScreen', false)
	}, 500)
})

export default router
